import { memo } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { isIE11 } from '../styles/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const privateSpin = keyframes(["100%{transform:rotate(360deg)}"]);
const privateDash = keyframes(["0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-50;}100%{stroke-dasharray:90,150;stroke-dashoffset:-140;}"]);
const SpinnerOuter = styled.div.withConfig({
  displayName: "LoadingSpinner__SpinnerOuter"
})(["align-items:center;color:", ";display:flex;flex-direction:column;height:100%;justify-content:center;position:relative;width:100%;"], ({
  theme
}) => theme.color.spinner.color);
const SpinnerInner = styled.div.withConfig({
  displayName: "LoadingSpinner__SpinnerInner"
})(["align-items:center;display:flex;height:28px;justify-content:center;width:28px;"]);
const SpinnerWrapper = styled.div.withConfig({
  displayName: "LoadingSpinner__SpinnerWrapper"
})(["opacity:1;transition:opacity 0.2s cubic-bezier(0.42,0,0.58,1),transform 0.2s cubic-bezier(0.89,0.03,0.68,0.22);", ""], isIE11() && css(["animation:", " 2s linear infinite;"], privateSpin));
const Ring = styled.svg.withConfig({
  displayName: "LoadingSpinner__Ring"
})(["display:block;max-width:100%;"]);
const RingPath = styled.circle.withConfig({
  displayName: "LoadingSpinner__RingPath"
})(["animation:", " 2s cubic-bezier(0.42,0,0.58,1) infinite,", " 2s linear infinite;stroke-dasharray:none;stroke-dashoffset:0;stroke-linecap:round;transform-origin:center;", ""], privateDash, privateSpin, isIE11() && `stroke-dasharray: 50, 150;`);
const LoadingSpinner = ({
  grow,
  role
}) => {
  return /*#__PURE__*/_jsx(SpinnerOuter, {
    grow: grow,
    role: role,
    children: /*#__PURE__*/_jsx(SpinnerInner, {
      children: /*#__PURE__*/_jsx(SpinnerWrapper, {
        children: /*#__PURE__*/_jsxs(Ring, {
          height: 28,
          stroke: '#7fd1de',
          viewBox: "0 0 50 50",
          width: 28,
          children: [/*#__PURE__*/_jsx("circle", {
            cx: "25",
            cy: "25",
            fill: "none",
            r: "22.5",
            strokeWidth: "5"
          }), /*#__PURE__*/_jsx(RingPath, {
            cx: "25",
            cy: "25",
            fill: "none",
            r: "22.5",
            stroke: '#00a4bd',
            strokeWidth: "5"
          })]
        })
      })
    })
  });
};
export default /*#__PURE__*/memo(LoadingSpinner);